import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchTerminalsDetails = (retailerId) => {
  const { url } = DepsService.rest.widgets.terminals.details;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const fetchTerminalsTemplates = () => {
  const { url } = DepsService.rest.widgets.terminals.templates;
  const queryParams = {};
  const urlParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/selling-terminals.api.js